/**
 * 根据整个Selector组件获取Key对应的Value
 * @param optionKey
 * @param dataval
 * @return val
 */
const getOptionValForDataVal = (optionKey,dataval)=> {
    if(dataval.Config === null) throw new Error("Config为空，请检查组件")
    const options = dataval.Config.Selector.Options
    return getOptionVal(optionKey,options)
}

/**
 * 根据Options获取Key对应的Value
 * @param optionKey
 * @param options
 */
const getOptionVal = (optionKey,options)=> {
    for (const optionInx in options) {
        const option = options[optionInx]
        if (option.Key === optionKey){
            return option.Value[0].Text
        }
    }
    return null
}

/**
 * 根据标题名获取Table中的控件
 * @param table
 * @param title
 */
const getChildrenForTable = (table,title) => {
    const children = table.Config.Table.Children
    const child = children.filter(e => e.Property.Title[0].Text === title)
    if (arrayIsEmpty(child)){
        return null
    }
    return child[0]
}

const getChildForTemplateLike = (controls,tableTitle,childTitle) => {
    const tables = controls.filter(e => e.Property.Title[0].Text.indexOf(tableTitle) !== -1)
    if (arrayIsEmpty(tables)){
        return null
    }
    let results = []
    tables.forEach(table => {
        let child = table.Config.Table.Children.filter(e => e.Property.Title[0].Text === childTitle)
        if (!arrayIsEmpty(child)){
            results.push(child[0])
        }
    })
    return results
}

/**
 * 根据表格名 + 子组件名 + 你所要获取的属性 就可以返回一个属性值的数组集合 isSelect值 如果为true 则回自动查到options
 * @param controls
 * @param tableTitle
 * @param childTitle
 * @param type
 * @param isSelect?
 * @return {[]}
 */
const getChildValueForTemplate = (controls,tableTitle,childTitle,type,isSelect = false) => {
    const children = getChildForTemplateLike(controls,tableTitle,childTitle)
    let results = []
    children.forEach(child => {
        if (isSelect){
            results.push(getOptionValForDataVal(child[type],child))
        }else{
            results.push(child[type])
        }
    })
    return results
}

const getChildValuesForTemplate = (controls,tableTitle,childTitle,isKey = false) => {
    const children = getChildForTemplateLike(controls,tableTitle,childTitle)
    let results = []
    for (const child of children) {
        let values = child["Values"];
        if (arrayIsEmpty(values) && !Array.isArray(values)){
            continue;
        }
        for (let value of values) {
            if (isKey){
                results.push(value)
            }else{
                const options = child.Config.Selector.Options.filter(e => e.IsShow)
                for (let option of options) {
                    if (option.Key == value){
                        let text = option.Value[0].Text
                        results.push(text)
                    }
                }
            }
        }
    }
    return results
}

/**
 * 去重
 * @param arr
 * @return {any[]}
 */
const distinct = arr => [...new Set(arr)]

const arrayIsEmpty = arr => arr === null || arr === undefined || arr.length <= 0


const convertHump = (jsonstr) => {
    let jsonObj = JSON.parse(jsonstr)
    renameDeep(jsonObj)
    return jsonObj
}

const renameDeep = function(jsonObj) {
    for (let item of Object.keys(jsonObj)) {
        let flag = false;
        let temp = jsonObj[item]
        if(temp instanceof Object && !(temp instanceof Array)){
            // console.log(temp)
            temp = renameDeep(temp)
        }
        if (temp instanceof Array && temp.length > 0) {
            if (temp[0] instanceof Object && !(temp[0] instanceof Array)){
                temp = renameDeep(temp)
                flag = true
            }
        }
        let names = [...item]
        names[0] = names[0].toUpperCase()
        let newItem = names.join("")
        jsonObj[newItem] = temp
        if (isNaN(item)){
            delete jsonObj[item]
        }
    }
    return jsonObj
}

const select = (arr,callback) => {
    let results = []
    for (const v of arr) {
        const result = callback(v)
        if(result !== null && result !== undefined) {
            results.push(result)
        }
    }
    return results
}

const intoItemToArray = (values) => {
    if (!Array.isArray(values)) {
        return values;
    }
    let result = []
    for(let i = 0;i<values.length;i++){
        result.push(values[i]);
    }
    if(result[result.length-1][0]=="SC24000029"){
        result.splice(result.length-1,0,["SC09120024","聂丽娟"]);
    }
    return result;
}

export {
    getOptionVal,
    getOptionValForDataVal,
    convertHump,
    select,
    getChildrenForTable,
    getChildValueForTemplate,
    distinct,
    getChildForTemplateLike,
    getChildValuesForTemplate,
    arrayIsEmpty,
    intoItemToArray
}